var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19562 7.11659C3.03438 6.19845 3.74082 5.35714 4.67301 5.35714H18.527C19.2553 5.35714 19.8784 5.88034 20.0044 6.59769L21.8107 16.8834C21.9719 17.8015 21.2655 18.6429 20.3333 18.6429H6.47933C5.75099 18.6429 5.12791 18.1197 5.00194 17.4023L3.19562 7.11659ZM4.67301 6.64286C4.53984 6.64286 4.43892 6.76304 4.46196 6.89421L6.26827 17.1799C6.28627 17.2824 6.37528 17.3571 6.47933 17.3571H20.3333C20.4665 17.3571 20.5674 17.237 20.5444 17.1058L18.7381 6.82008C18.7201 6.7176 18.631 6.64286 18.527 6.64286H4.67301Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66772 11.1429C7.66772 10.7878 7.95554 10.5 8.31058 10.5H16.6957C17.0507 10.5 17.3385 10.7878 17.3385 11.1429C17.3385 11.4979 17.0507 11.7857 16.6957 11.7857H8.31058C7.95554 11.7857 7.66772 11.4979 7.66772 11.1429Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46443 6.64286H5.51562V5.35714H4.46443C3.7294 5.35714 3.10774 5.88991 2.98351 6.60691C2.66996 8.4165 2.41237 9.66921 2.15488 10.9139C2.14801 10.9472 2.14113 10.9805 2.13425 11.0137C1.88315 12.2274 1.63051 13.4485 1.32739 15.1742C1.16633 16.0911 1.87364 16.9286 2.80179 16.9286H5.51562V15.6429H2.80179C2.66991 15.6429 2.57138 15.5238 2.59371 15.3966C2.89346 13.6902 3.14283 12.4848 3.39375 11.272L3.41394 11.1744C3.67216 9.9261 3.93315 8.65703 4.25035 6.82642C4.26907 6.71837 4.36212 6.64286 4.46443 6.64286Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/Reservation.37d37b43d67a0655f9a4f5e6babf9795.svg";
export { ForwardRef as ReactComponent };